import { SettingsPageForm } from './settings-page-form'

export const SettingPage = () => {
    return <SettingsPageForm />
}
